import { render, staticRenderFns } from "./Createuser.vue?vue&type=template&id=39e15bd2&"
import script from "./Createuser.vue?vue&type=script&lang=js&"
export * from "./Createuser.vue?vue&type=script&lang=js&"
import style0 from "./Createuser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports